module.exports = __webpack_public_path__ + "static/media/video4_photo.7cde828e.jpg";